/* eslint-disable complexity */
import {
  BookWidgetAem,
  BookWidgetFields
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BOOK_WIDGET_ERROR_CODES } from '../../constants/error-codes.constants';
import { isAlphaNumeric } from '../utils/utils.adapter';

export const validateMeetingEventCode = (
  bookWidgetFields: BookWidgetFields,
  fieldsErrorCount: number,
  startFieldsValidation: boolean,
  bookWidgetAem: BookWidgetAem | null
) => {
  const updatedBookWidgetFields = {
    ...bookWidgetFields,
    meetingEventCodeField: { ...bookWidgetFields.meetingEventCodeField }
  };

  delete updatedBookWidgetFields.meetingEventCodeField.fieldErrorInfo;

  const { meetingEventCodeField } = updatedBookWidgetFields;

  if (
    startFieldsValidation &&
    !meetingEventCodeField.hide &&
    meetingEventCodeField.meetingEventCodeValue &&
    !isAlphaNumeric(meetingEventCodeField.meetingEventCodeValue)
  ) {
    let errorMessage = 'Error';
    if (
      bookWidgetAem?.errorMessages?.[
        BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_INVALID_MEETING_CODE
      ]?.message
    ) {
      errorMessage =
        bookWidgetAem.errorMessages[
          BOOK_WIDGET_ERROR_CODES.BOOK_FIELD_ERROR_INVALID_MEETING_CODE
        ].message;
    }
    meetingEventCodeField.fieldErrorInfo = {
      errorMessage
    };
    fieldsErrorCount++;
  }

  return { fieldsErrorCount, updatedBookWidgetFields };
};
